module.exports = __webpack_public_path__ + "img/banner_dymmy_golf.2c8c1b2f.png";